import { Button, ButtonLink } from "@/components/Buttons";
import { TextField } from "@/components/Form/Parts/index";
import routes from "@/lib/routes";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { useUppercaseCaution } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const schema = y.object().shape({
  mailAddress: y.string().email("メールアドレスの形式で入力してください。").required("メールアドレスが入力されていません。")
});
export default function Step1(_ref) {
  var _errors$mailAddress;
  let {
    onSubmit,
    error
  } = _ref;
  const {
    formState,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isDirty,
    isValid,
    isSubmitting
  } = formState;
  const [handleChange, uppercaseCautionMessage] = useUppercaseCaution();
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsxs("p", {
          children: ["SPOOX ID\u3068\u3057\u3066\u3054\u5229\u7528\u3044\u305F\u3060\u304FE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u5165\u529B\u3057\u305FE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u5C4A\u3044\u305F4\u6841\u306E\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u6B21\u30DA\u30FC\u30B8\u3067\u5165\u529B\u3057\u3066\u767B\u9332\u3092\u9032\u3081\u3066\u304F\u3060\u3055\u3044\u3002"]
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(TextField, {
            ref: register,
            title: "E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF08\u30ED\u30B0\u30A4\u30F3ID\uFF09",
            type: "email",
            name: "mailAddress",
            placeholder: "\u534A\u89D2\u82F1\u6570\u5B57\u3067\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B",
            caption: "ドメイン指定受信に「skyperfectv.co.jp」を設定してください。",
            error: ((_errors$mailAddress = errors.mailAddress) === null || _errors$mailAddress === void 0 ? void 0 : _errors$mailAddress.message) || (error === null || error === void 0 ? void 0 : error.message) || uppercaseCautionMessage,
            onChange: handleChange,
            autoComplete: "email",
            required: true
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillMainColor: true,
        fontFixed: true,
        large: true,
        disabled: !isDirty || !isValid,
        loading: isSubmitting,
        children: "\u8A8D\u8A3C\u30B3\u30FC\u30C9\u3092\u9001\u4FE1\u3059\u308B"
      })
    })]
  });
}